interface Env {
  link: string
  user: string
  pwd: string
}

interface EnvConfig {
  test?: Env
  uat?: Env
  pro?: Env
}

export interface KitItem {
  id: number;
  avatarUrl: string
  appName: string
  env: EnvConfig
}

export const apps: KitItem[] = [
  {
    id: 11,
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/dcc8/e084/b528/0719bcdd-825b-480e-8ccd-fe00671216c4',
    appName: 'CD发布系统',
    env: {
      pro: {
        link: 'http://vpub.visioneschool.com/',
        user: '000561',
        pwd: 'xiao123'
      }
    }
  },
  {
    id: 12,
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/6bb8/bc54/7780/25f58821-0877-45cb-8bb6-dd4d137e2b65',
    appName: 'Sentry',
    env: {
      pro: {
        link: 'https://sentry.visioneschool.com/',
        user: 'aliyun.jishubu@visionacademy.cn',
        pwd: 'kjBy!Q0!^Xa*'
      }
    }
  },
  {
    id: 13,
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/f14a/abc4/e6c4/ccadba86-4c6e-4cba-a41f-5ca27b13c622',
    appName: 'Consul',
    env: {
      pro: {
        link: 'https://app-consul.visioneschool.com/',
        user: '',
        pwd: ''
      }
    }
  },
  {
    id: 14,
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/d58a/51f4/f140/7fe910d6-041f-4f15-a85d-db3278df3b9a',
    appName: 'JIRA',
    env: {
      pro: {
        link: 'http://jira.visioneschool.com/',
        user: '',
        pwd: ''
      }
    }
  },
  {
    id: 15,
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/e48b/b044/f1d8/c7c4e948-8d1f-440b-b84e-6b76bf4f919a',
    appName: 'Confluence',
    env: {
      pro: {
        link: 'http://confluence.visioneschool.com/',
        user: '',
        pwd: ''
      }
    }
  }
]
